import { render } from "./PreloaderPractice.vue?vue&type=template&id=7e73411c&scoped=true"
import script from "./PreloaderPractice.vue?vue&type=script&lang=js"
export * from "./PreloaderPractice.vue?vue&type=script&lang=js"

import "@/css/components/preloader-practice.css?vue&type=style&index=0&id=7e73411c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e73411c"]])

export default __exports__